export default __webpack_public_path__ + "static/media/reschedule-icon.aa8a089c.svg";